import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { Modal, Button } from '@getro/rombo';
import { useUpsellTracking } from 'hooks/useUpsellTracking';
import upsellIllustration from '../../../assets/upsell-illustration.svg';

const CTA_URL = 'https://scheduler.zoom.us/brett-bazzini/30-min-meeting';

const UpgradeModal = ({ isOpen, onClose, featureName, title, subtitle }) => {
  const { trackPaywallShown, trackDemoClick } = useUpsellTracking();

  useEffect(() => {
    if (isOpen) {
      trackPaywallShown(featureName);
    }
  }, [isOpen, featureName, trackPaywallShown]);

  const handleCtaClick = () => {
    trackDemoClick(featureName);
    window.open(CTA_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Modal isOpen={isOpen} onCancel={onClose}>
      <Flex sx={{ flexDirection: 'column', alignItems: 'flex-start', gap: '16px', textAlign: 'center', p: '16px' }}>
        <Box as="img" src={upsellIllustration} alt="Upgrade" sx={{ width: '120px', height: 'auto' }} />

        <Flex sx={{ flexDirection: 'column', gap: '8px', alignItems: 'flex-start' }}>
          <Text sx={{ fontSize: '20px', fontWeight: 700, color: 'text.dark' }}>{title}</Text>
          <Text sx={{ fontSize: '16px', fontWeight: 400, color: 'text.main' }}>{subtitle}</Text>
        </Flex>

        <Button onClick={handleCtaClick} variant="primary">
          Contact our team
        </Button>
      </Flex>
    </Modal>
  );
};

UpgradeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  featureName: PropTypes.string.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

UpgradeModal.defaultProps = {
  title: 'Upgrade your plan to access this feature',
  subtitle: "Our team will help you upgrade if you'd like to enable it.",
};

export default UpgradeModal;
